export default "__VITE_ASSET__Dnpf$YAw__"